module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n';
 if (options.loadHomePageURLOnClick) { 
__p+='\n    <a href="'+
((__t=( location.home_page_url ))==null?'':__t)+
'" target="_blank">'+
((__t=( location.name ))==null?'':__t)+
'</a>\n';
 } else { 
__p+='\n    <a href="#/all/location/'+
((__t=( location.slug ))==null?'':__t)+
'">'+
((__t=( location.name ))==null?'':__t)+
'</a>\n';
 } 
__p+='';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/available-at-locations/available-at-location.html
 ** module id = 140
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 16 17 22 25 26 155
 **/